import { Pipe, PipeTransform } from "@angular/core";
import { FlightsService } from "../../flights-calendar/flights.service";

@Pipe({
    name: "flightType",
    standalone: false,
})
export class FlightTypePipe implements PipeTransform {
    constructor(private _flightsService: FlightsService) {}

    transform(flightTypeId: number): string {
        const flightTypeArray = this._flightsService.getFlightAttributesArray().flightTypes;
        const flightType = flightTypeArray.filter((type) => type.id === flightTypeId)[0];
        return !flightType ? "N/D" : flightType.name;
    }
}
